import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Python and lazy evaluation",
  "description": "",
  "published": "2012-08-24T00:00:00.000Z",
  "redirect_from": ["/blog/python-and-lazy-evaluation/swizec/5148"],
  "categories": "Lazy evaluation, Prime number, python, Sequence, Time complexity, Uncategorized",
  "hero": "./img/6182-6115496574_35ca6b4cf8_z.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://www.flickr.com/photos/tarasantilli/6115496574/"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "66.81614349775785%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'267\\'%20viewBox=\\'0%200%20400%20267\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M98%202v4l-1%202v16l1%203c2%203%204%203%204-2l3-11%2010-12c1-2%201-2-7-2s-9%200-10%202m189-1l3%204c4%203%203%203%2025%205l22%203c11%204%2017%205%2024%206%2010%200%2014%204%205%205l-8%202c-3%202-7%207-5%208l1%202c-1%202%205%209%208%209l4%203c4%203%203%203%2017%203%207%200%2011-1%2012-2l3-1c3%200%203%2072%201%2074-4%203-22%205-26%203-2-1-8%201-10%202l-3%201-2%201-2%201c-4%200-5%205-3%2012v10c-3%208-2%2014%201%2014%202%201%202%201%201%202l-3%206-2%206%201%203v3l-2%206c-1%204-1%204-3%202-2-1-2-2-1-2%202%200%202-1%201-3l-1-3-2%203c0%202-2%203-3%203l-3%203c-1%203-2%203-5%203-4%200-4%200-3-1l2-2c0-2-3-1-5%201-2%201-3%202-5%201s-3-1-5%201l-1%202%201%201h-1c-2-1-5%201-5%203l-4%207c-1%200-2%201-1%202l-1%202v4c1%205-12%2014-14%209%200-3-4-2-4%200-1%202-3%203-7%202l-1%202c-1%202-4%203-5%201h-22c-1%201-3%202-9%202l-4%202h-2c-1-1-2%200-4%201l-4%201c-2-1-5%200-5%202l-1%201-1-3-1-3-1%202c0%202-1%203-3%200h-1l1%202%201%203v3l-2-3c-1-2-2-3-3-2h-6l-1-1c0-2-2-1-3%202s-2%203-5-1c-3-2-3-2-2-4l1-4%201-3c2-2%201-3-2-3s-3%201-3%205c0%205%200%205-3%206-1%201-2%201-2-1l-2-1v2c0%202%200%202-2%201h-3c-2%202-6%201-6-1%200-3-2-3-3%200l-4%202h-4c-1%200-2%200-2%202h-6c-3%202-3%202-4%200-1-1-4%200-4%203l-1%201-2-1-1-1-3-1-5-3-6-2c-3-2-10-1-8%202%200%202-5%200-11-5l-8-4c-2%200-11%206-12%208l-4%201-3%201-1%201-2%201-2%201-2%202-3%202h-4c0-2%201-3%205-8%201-1%201-2-2-5-2-1-2-2-1-3%202-1%201-2-3-3l-4-2-3-4c-2-1-3-3-2-3l-3-2-3-1-1-1c-2%200-2-1-2-4l-1-4-4-7%201-1%202-1%206-1%208-2%208-1c6%200%207-1%208-6%202-7%200-9-8-8l-9-2-5-1c-4%200-6-2-6-8l-1-7-1-8-1-5c-2%200-3-5-4-16a296%20296%200%2000-3-37%20768%20768%200%2000-6-53l-1-11-3-11-2-6-1-4c0-3%200-4-2-4l-6-3-5-2-8%202H0v262h401V138L400%204V0h-57l-56%201M88%207l-6%202-2%201-5%202c-7%203-32%207-28%204%201-1%201-1-1-2-2-2-6-2-6%200v27c3%2019%203%2021%205%2055a202%20202%200%20003%2029l3%207v6c-2%204%202%2026%205%2030%203%205%206-6%203-12v-4l-2-4v-8c0-3-1-4-1-2h-1l-1-2c-1-1%201-7%202-7v-2l2-3%202-3%202-3%204-3c4-4%205-8%202-28-2-18-3-25-4-21-1%202-1%202-2-5l1-5%201-2c0-2%200-2%204-1l4-1h1c2%200%204-5%204-8v-6c1-1%202-4%201-5l2-9%202-2%204-4%201-2v-2c1-1%201-1%201%201l3-3c3-6%203-6-3-5m33%2035l-1%203-3%209c-4%207-4%2011%200%2014l5%204%206%205%206%204%202%202-3%201c-5%202-9%209-13%2018-3%208-2%2013%201%2020s16%2018%2018%2015h2c6%205%2012%205%2017%200l6-5%203-2c0-2%203-4%204-4%202%201%2015-17%2018-27%203-6%203-9-1-10l-4-3-4-2a479%20479%200%2001-52-40c-5-4-6-5-7-2m160%2018a527%20527%200%2001-49%2027l-11%207c-4%202-5%207-3%207s2%201%202%203l2%205%202%204%201%202v2l1%203%201%204%204%206%203%203%201%202%202%202%2011%207h2l5%202c9%207%2030-2%2036-15a46%2046%200%2000-1-28l-2-4-2-3-4-3c-5-3-5-4-1-5s12-5%2013-7l3-1c5%200%206-1%202-7l-6-11c-2-7-4-7-12-2M137%2091c-16%208-14%2034%202%2041%2014%205%2031-4%2035-18%203-8%203-9-4-12l-21-12c-3-2-7-2-12%201m127%206a255%20255%200%2001-18%208l-8%203-6%203%201%204c4%2027%2043%2035%2053%2011%206-16-8-35-22-29m-120%208c-4%203-4%207-1%2010%204%206%2014%202%2014-6%200-6-8-9-13-4m113%205c-4%203-5%208-1%2012%205%206%2015%202%2014-6-1-6-8-9-13-6m-113%2053c-1%202-2%204-1%208v6l-1%202%201%203%201%201v4c0%202%200%202-2%200-3-2-5%200-2%203s4%204%204%202%201-2%203-2%203%200%202-1l-3-19c0-11%200-11-2-7m45%2017l-3%204-1-1v-3l-1%203c0%203%200%204-1%203-2%200-2%200-2%202s1%203%203%201c1-1%201-1%201%201l1%202v1c-2%201-2%201%201%201l3%201-3%201-3%201h4c4%201%207%206%205%209-1%202-1%202%201%202l3-3c0-4%201-4%203-4s3%200%203%202l-2%203%201%201%201-1%203-2v2l-1%203c0%203-1%202-3%200s-5-2-4%200c0%202-5%202-7%200s-5-1-4%201h-2c-3-2-4%200-1%202l2%203%201%201%202%204%204%203v1l2%202%202-1h5c1-2%203-3%206-4%204%200%206-2%206-4v-1l2-5c0-3%201-5%203-5%203-2%202-3-2-3h-3c2-2%202-2%200-2l-2%201c0%202-3%201-9-2l-8-4-1-1-2-2-3-2c0-2%202-4%203-2h2c1%200%202-5%200-5l-1-3c0-2%200-2%202-1l2-1-2-1-2-1c-1-3-3-2-4%203m65%200l-1%202c0%202-11%2019-15%2024-3%203-4%206%200%203l2-1%206-3%202-2h2v-2h-3c-2%200-2%200-1-2l2-2c3%200%204%200%203-1-1-2%201-8%202-6l2-8c1-2%200-3-1-2m91%2030c-4%203-4%203%202%206%204%203%205%203%205%201l2%202c2%204%202%204%204%200%201-3%201-3%2010-3%2010%200%2011%201%2011%208l1%204c1%202%204%201%204-1l2-1%201-1c-1-2%202-9%203-9l3-1c2-3-8-6-17-5h-10l-11-2c-7%200-8%200-10%202m-112%201l-5%202c-2%203-8%205-8%204l-2-1c-2-1-3%201-1%202%201%200%201%201-3%202-4%202-5%205-1%204l8-1h2c1%201%201%201%201-1l2-2%201%202%201%201v-2c0-2%204-8%206-8%201%201%201%200%201-1v-2l-2%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/4d186fc6d8f7ffab10379ee23105b1bb/ca0a1/6182-6115496574_35ca6b4cf8_z.webp 223w", "/static/4d186fc6d8f7ffab10379ee23105b1bb/75680/6182-6115496574_35ca6b4cf8_z.webp 445w", "/static/4d186fc6d8f7ffab10379ee23105b1bb/0ba47/6182-6115496574_35ca6b4cf8_z.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/4d186fc6d8f7ffab10379ee23105b1bb/853b2/6182-6115496574_35ca6b4cf8_z.jpg 223w", "/static/4d186fc6d8f7ffab10379ee23105b1bb/0a4fe/6182-6115496574_35ca6b4cf8_z.jpg 445w", "/static/4d186fc6d8f7ffab10379ee23105b1bb/c08c5/6182-6115496574_35ca6b4cf8_z.jpg 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/4d186fc6d8f7ffab10379ee23105b1bb/c08c5/6182-6115496574_35ca6b4cf8_z.jpg",
                "alt": "Lazy, by CurlysGirly",
                "title": "Lazy, by CurlysGirly",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Lazy, by CurlysGirly`}</figcaption>{`
  `}</figure></a></p>
    <p>{`I woke up this morning with a clear thought in mind `}<em parentName="p">{`"Generators are awesome! I will write a post about using them for lazy evaluation! Hoorah"`}</em></p>
    <p>{`After much dabbling I realized how wrong I was. `}<a parentName="p" {...{
        "href": "http://www.python.org/",
        "title": "Python (programming language)"
      }}>{`Python`}</a>{`'s generators are indeed cool. They give us the use of `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Lazy_evaluation",
        "title": "Lazy evaluation"
      }}>{`infinite lists`}</a>{` and they're useful for conserving memory usage, but lazy evaluation they can't quite do.`}</p>
    <p>{`Let's make a generator for natural numbers:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`def generator():
    i = 1
    while True:
        yield i
        i += 1
`}</code></pre>
    <p>{`A simple function with a loop counting from one to infinity. The `}<em parentName="p">{`yield`}</em>{` operator is what saves us from looping into infinity by turning the function into a generator. We can now take any number of natural numbers:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`from itertools import islice

def take(n, iterable):
    "Return first n items of the iterable as a list"
    return list(islice(iterable, n))

print take(5, generator())
# [1, 2, 3, 4, 5]
`}</code></pre>
    <p>{`Cool, we've implemented python's native `}<em parentName="p">{`range`}</em>{` function. Handy, bot nothing special.`}</p>
    <p>{`The power of generators lies in using something more than `}<em parentName="p">{`+1`}</em>{` as the core function. How about implementing a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Algorithm",
        "title": "Algorithm"
      }}>{`naive algorithm`}</a>{` for listing prime numbers?`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`def primes():
    for n in generator():
        if not any(i > 1 and i != n and n%i == 0
                   for i in islice(generator(), n)):
            yield n

print take(10, primes())
# [1, 2, 3, 5, 7, 11, 13, 17, 19, 23]
`}</code></pre>
    <p>{`Ok the number one might not be prime, but that's easily fixable by changing the generator we're iterating over in the `}<em parentName="p">{`primes()`}</em>{` function so it starts at 2 instead of 1.`}</p>
    <p>{`But this algorithm is slow for anything significant. It would be great if we could improve it by only doing trial divisions with known primes rather than everything.`}</p>
    <p>{`But ... we can't do that. At least I haven't found a good way to do it. Logically speaking, we should be able to iterate over a list of all `}<em parentName="p">{`primes()`}</em>{` as long as the numbers returned are smaller than the one we are currently checking:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`def primes():
    for n in generator():
        if not any(p != n and n%p == 0
                   for p in takewhile(lambda x: n>x,
                                      primes())):
            yield n

print take(10, primes())
`}</code></pre>
    <p>{`This produces an `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Infinite_loop",
        "title": "Infinite loop"
      }}>{`infinite recursion`}</a>{` and the script dies after spitting out a bunch of errors. It might look like we aren't doing anything to stop the recursion, we actually are.`}</p>
    <p>{`Internally `}<em parentName="p">{`primes()`}</em>{` is stopped by the `}<em parentName="p">{`takewhile`}</em>{` since it only takes from the generator while a condition is met. And externally it's stopped by the `}<em parentName="p">{`take()`}</em>{` since it finishes after 10 primes have been yielded.`}</p>
    <h2 {...{
      "id": "no-laziness-"
    }}>{`No laziness :(`}</h2>
    <p>{`By no means are generators bad - using generator comprehensions instead of `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/List_comprehension",
        "title": "List comprehension"
      }}>{`list comprehensions`}</a>{` is a `}<strong parentName="p">{`great`}</strong>{` idea. It will save plenty of memory when you're doing something like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`# builds a big list and immediately discards it
>>> sum([x*x for x in xrange(2000000)])
2666664666667000000L

# only keeps one value at a time in memory
>>> sum(x*x for x in xrange(2000000))
2666664666667000000L
`}</code></pre>
    <p>{`As noted in `}<em parentName="p"><a parentName="em" {...{
          "href": "http://python3porting.com/improving.html"
        }}>{`Improving your code with modern idioms`}</a></em>{` a lot of cool tricks like that have been backported from python 3 and you should start using them.`}</p>
    <p>{`But what's happened to our dreams of lazy evaluation?`}</p>
    <p>{`We can check that Python is indeed very eager to evaluate everything:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`>>> ["no sleep", time.sleep(1), time.sleep(2)][0]
'no sleep'  # takes 3 seconds to print
`}</code></pre>
    <p>{`As this example shows python immediately evaluates the whole data structure with wanton disregard for what you're actually using. Even doing it as a tuple doesn't work.`}</p>
    <p>{`Using a generator helps a little bit`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`>>> list(islice((time.sleep(x) for x in xrange(3)), 1))
[None] # takes 0 seconds
>>> list(islice((time.sleep(x) for x in xrange(3)), 2))
[None, None] # takes 1 second
>>> list(islice((time.sleep(x) for x in xrange(3)), 3))
[None, None, None] # takes 3 seconds
`}</code></pre>
    <p>{`But this is awkward. Our only other bet is using lambda's to postpone evaluation of particular members of a list until they're actually needed:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`>>> [lambda: "no sleep", lambda: time.sleep(1), lambda: time.sleep(2)][0]()
'no sleep' # takes 0 seconds
`}</code></pre>
    <p>{`Only somewhat awkward to use and it isn't even real lazy evaluation. Of course nothing gets evaluated eagerly when we're just assigning functions to variables so they can be called later. It's a trick that works in all languages that permit storing functions. Javascript comes immediately to mind.`}</p>
    <p>{`While we `}<em parentName="p">{`might`}</em>{` be able to expand on this lambda and generator trickery throughout our codebase ... let's not. Let's be content that python is an eager language, asking only `}<em parentName="p">{`"How high?"`}</em>{` when we tell it to jump, and rejoice in the fact it can be kind of sort of almost lazy when we explicitly tell it to be.`}</p>
    <h2 {...{
      "id": "update-may-16th-2016"
    }}>{`Update May 16th, 2016`}</h2>
    <p>{`Reader Jasen Betts fixed a bug in my lazy eval implementation. Here's what he has to say:`}</p>
    <p>{`Note that takewhile does not stop UNTIL it finds an unacceptable result, it has to find the first unacceptable result to terminate. That's why your second primes function doesn't work.`}</p>
    <p>{`Code that works:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`def primes():

    # print ("(yield=2)")
    yield 2

    for f in generator():
        n=f*2+1
        if not any(p != n and n%p == 0
                for p in takewhile(lambda x: n>=x*x, primes())
                );
            # print ("(yield=%d)"%(n) )
            yield n
`}</code></pre>
    <p>{`points to note`}</p>
    <p>{`\``}{`yield 2`}{`\``}{` and `}{`\``}{`n>=x`}{`*`}{`x`}{`\``}{` ensure that it terminates by ensuring the racursive calls require smaller maximum results`}</p>
    <p>{`\``}{`n=f`}{`*`}{`2+1`}{`\``}{` helps efficiency, but `}{`\``}{`n=f+2`}{`\``}{` would also work. after `}{`\``}{`yield 2`}{`\``}{` we need to start searching at 3.`}</p>
    <p>{`It's still horribly inefficient uncomment the `}{`\``}{`print()`}{`\``}{` calls to see why.`}</p>
    <p>{`Perhaps this can be fixed by storing the found results in a dict and yielding those first before looping over the generator.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      